import React from 'react'
import { IProps } from './Interface'
import { Balloon } from 'components'
import { Corner } from 'components/balloon'
import { Box, useTheme, useMediaQuery, Grid, GridDirection, GridItemsAlignment, Typography } from '@material-ui/core'
import useStyles from './Styles'

const PursuitsPageDisplay: React.FC<IProps> = ({ passions }) => {
  const classes = useStyles({})
  const theme = useTheme()
  const xsSize = useMediaQuery(theme.breakpoints.down('xs'))
  const colors = [theme.palette.common.lightPurple, theme.palette.common.lightBlue, theme.palette.common.orange]

  return (
    <Box className={classes.root}>
      {passions.map((passion, index) => (
        <Box mb={2} key={index} className={`i-pursue-with-intensity-section-${index + 1}`}>
          <Box className={classes.passionContainer}>
            <Box display="flex">
              <Balloon
                size={xsSize ? 30 : 38}
                corner={xsSize ? Corner.MiddleRight : Corner.BottomLeft}
                shadow={false}
                bgColor={colors[index]}
                flexShrink={0}
                mr={2}
              />
              <Grid
                container
                direction={'row' as GridDirection}
                alignItems={'center' as GridItemsAlignment}
                className={classes.freeTextRoot}
              >
                <Grid item className={classes.titleInputContainer}>
                  <Typography id={`${index}-pursuits-page-title-label`} style={{ color: colors[index] }}>
                    {passion.title}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box className={classes.detailBox}>
              <Grid
                container
                direction={'row' as GridDirection}
                alignItems={'center' as GridItemsAlignment}
                className={classes.freeTextRoot}
              >
                <Grid item className={classes.detailInputContainer}>
                  <Typography id={`${index}-pursuits-page-detail-answer`}>{passion.detail}</Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

PursuitsPageDisplay.defaultProps = {
  isLastChildren: false
}

export default PursuitsPageDisplay
